// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import templateGdbtf from './routes/gdbtf';
import aboutUs from './routes/about';
import templateFruts from './routes/fruts';
import multimedia from './routes/multimedia';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Grant Dizionari
  templateGdbtf,
  //anteporta fruts
  templateFruts,
  //anteporta multimedia
  multimedia,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js